import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RelayBoard} from '../../../classes/RelayBoard';
import {Relay} from '../../../classes/Relay';
import {RelayBoardService} from '../../../services/relay-board.service';

@Component({
  selector: 'app-relay-edit',
  styleUrls: ['./relay-edit.component.scss'],
  templateUrl: './relay-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RelayEditComponent implements OnInit {

  @Input() relay: Relay;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  relayBoards: RelayBoard[];

  public relayForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private relayBoardService: RelayBoardService) {}

  ngOnInit(): void {

    if (this.relay) {
      this.relayForm = this.formBuilder.group({
        id: [this.relay.id],
        name: [this.relay.name, Validators.required],
        relayBoardId: [this.relay.relayBoardId, Validators.required],
        relayId: [this.relay.relayId, Validators.required],
        description: [this.relay.description]
      });
    } else {
      this.relayForm = this.formBuilder.group({
        id: [''],
        name: ['', Validators.required],
        relayBoardId: ['', Validators.required],
        relayId: [null, Validators.required],
        description: ['']
      });
    }

    this.relayBoardService.getAll().subscribe({
      next: (response: RelayBoard[]) => this.relayBoards = response,
      error: err => console.log(err.error) // TODO handle error
    });
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
